import { render, staticRenderFns } from "./CustomerUsers.vue?vue&type=template&id=3b40da94"
import script from "./CustomerUsers.vue?vue&type=script&lang=js"
export * from "./CustomerUsers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports